import { Article, HomeRepairServiceTwoTone, Label } from '@mui/icons-material'
import { Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Switch } from '@mui/material'
import React from 'react'
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import SettingsIcon from '@mui/icons-material/Settings';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import LogoutIcon from '@mui/icons-material/Logout';
import ModeNightIcon from '@mui/icons-material/ModeNight';

export const Sidebar = ({mode,setMode}) => {
  return (
    <Box flex={1} padding={2} sx={{display : {xs:"none", sm : "block"}}}>
   <Box position="fixed">

  

    
    <List>
          <ListItem disablePadding>
            <ListItemButton component="a" href="#home">
              <ListItemIcon>
                {/* <InboxIcon /> */}
                <HomeRepairServiceTwoTone/>
              </ListItemIcon>
              <ListItemText primary="Homepage" />
            </ListItemButton>
          </ListItem>


          <ListItem disablePadding>
            <ListItemButton component="a" href="#home">
              <ListItemIcon>
                {/* <InboxIcon /> */}
                <Article/>
              </ListItemIcon>
              <ListItemText primary="Pages" />
            </ListItemButton>
          </ListItem>

       

          <ListItem disablePadding>
            <ListItemButton component="a" href="#home">
              <ListItemIcon>
                {/* <InboxIcon /> */}
                <PersonAddIcon/>
              </ListItemIcon>
              <ListItemText primary="Friends" />
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton component="a" href="#home">
              <ListItemIcon>
                {/* <InboxIcon /> */}
                <SettingsIcon/>
              </ListItemIcon>
              <ListItemText primary="Settings" />
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton component="a" href="#home">
              <ListItemIcon>
                {/* <InboxIcon /> */}
                <AccountBoxIcon/>
              </ListItemIcon>
              <ListItemText primary="Profile" />
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton component="a" href="#home">
              <ListItemIcon>
                {/* <InboxIcon /> */}
                <LogoutIcon/>
              </ListItemIcon>
              <ListItemText primary="Logout" />
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton component="a" href="#home">
              <ListItemIcon>
                {/* <InboxIcon /> */}
                <ModeNightIcon/>
              </ListItemIcon>
              <Switch onChange={e=>setMode(mode === "light" ?  "dark" : "light")}/>
            </ListItemButton>
          </ListItem>

          </List>
    
          </Box>
    </Box>
  )
}
